import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import styles from "./PastActionItem.module.css";
import classNames from "classnames";

export function PastActionItem({ onClick, index, actionDetails }) {
  const shortNumber = actionDetails.id.substring(0, 8) + "...";
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US");
  };

  return (
    <div
      className={classNames(styles.container, index % 2 !== 0 && styles.gray)}
      // className={styles.container}
      // style={{
      //   background: index % 2 !== 0 ? "rgba(200, 200, 200, 0.2)" : "none",
      // }}
    >
      <Link to={`/security/incident/${actionDetails.id}`}>
        <div
          className={styles.actionLink}
          onClick={() => onClick(actionDetails.id)}
        >
          {shortNumber}
        </div>
      </Link>
      <div className={styles.gridItem}>
        {actionDetails.historyOfActions[0].text}
      </div>
      <div className={styles.lastItemDate}>
        {formatDate(actionDetails.historyOfActions[0].createdAt)}
      </div>
    </div>
  );
}

PastActionItem.propTypes = {
  /**Function called when the incident number is clicked */
  onClick: PropTypes.func,
  /**Displays the background color of the item */
  index: PropTypes.number,
  /**Object with details about the incident (number-String, type-String, date-String)  */
  actionDetails: PropTypes.shape({
    number: PropTypes.string,
    type: PropTypes.string,
    date: PropTypes.string,
  }),
};
